import React from 'react';

export const SIGNUP_TERMS_INLINE_CSS = `
  .signup-terms-inline {
    text-align: center;
    font-size: .75rem;
    line-height: 1.45;
    color: var(--text-dim, #6B6B6B);
    font-weight: 400;
    margin: .15rem 0 .85rem;
  }
  .signup-terms-inline a {
    color: var(--primary, #D32F2F);
    font-weight: 600;
    text-decoration: underline;
  }
`;

/**
 * Clickwrap do braço `guided`: o texto completo abre em outra aba
 * (`/termos-de-uso`), e o botão da tela declara o aceite.
 */
const SignupTermsInlineNotice = () => (
  <p className="signup-terms-inline">
    Ao tocar no botão abaixo, você declara que leu e aceita os{' '}
    <a href="/termos-de-uso" target="_blank" rel="noopener noreferrer">
      Termos de Uso e Privacidade
    </a>
    .
  </p>
);

export default SignupTermsInlineNotice;
